{ bool, func, instanceOf, string, object, oneOfType } = PropTypes
insertExtension = require 'components/document_sections/v2/editor_extensions/insert/insert'
InsertedGdtTable = require 'components/evidence_syntheses/inserted_gdt_table'
InsertModal = require 'components/etd/insert_modal'
EtdEditorErrorBoundary = require 'components/etd/etd_editor_error_boundary'
{ getEpiditorContent, hasContentChanged, resetSelection } = require 'lib/epiditor_utils'
mediator = require 'mediator'
ReferencesInsertModal = require 'components/etd/references_insert_modal'
ReferenceCitationMixin = require 'components/mixins/reference_citation_mixin'
Translation = require 'components/mixins/translation'
{ useEditorReady } = require 'components/enhancers/editor_ready_context'
{
  default: EpiditorComponent
  resetState: resetEditorState
  createControlExtension
  serializeState: serializeEditorState
} = Epiditor
{ useCallback, useEffect } = React

editorUtils = Editor.EditorUtils
GdtEditorWithApply = Editor.EditorWithApply
GdtEditor = Editor.Editor

serializeEditorStateWithNewEditor = (state) ->
  _.extend newEditor: true, serializeEditorState state

EtdEditor = createReactClass
  displayName: 'EtdEditor'

  propTypes:
    additionalOptions: object
    attachments: instanceOf(Immutable.Map)
    cellId: string.isRequired
    className: string
    content: oneOfType [instanceOf(Immutable.Map), string]
    forceTableExpand: bool
    isConsensus: bool
    minimal: bool
    noAutoSave: bool
    noInsertOption: bool
    noReferencesInsert: bool
    onChange: func
    onFocus: func
    onSaveContent: func
    onSaveAttachment: func
    placeholder: string
    questionType: string
    renderMode: string
    stickControlsTo: string
    withApplyCancelButtons: bool

  getDefaultProps: ->
    additionalOptions: null
    className: null
    forceTableExpand: false
    isConsensus: false
    minimal: false
    noAutoSave: false
    noInsertOption: false
    noReferencesInsert: false
    placeholder: null
    stickControlsTo: '#recommendations'
    withApplyCancelButtons: true
    onSaveAttachment: null
    onSaveContent: null

  mixins: [
    Translation('')
    ReferenceCitationMixin()
  ]

  getInitialState: ->
    showInsertModal: false
    showCancelApply: false
    isNewEditorEditing: false
    newEditorError: null

  _isNewEditor: ->
    @props.content?.newEditor or mediator.project.get('useNewEditorInEtd')

  getContent: ->
    if @_isNewEditor()
      return serializeEditorStateWithNewEditor @newEditorView.state if @newEditorView
    else
      return @gdtEditor?.getEditorContent()

  resetContent: (content) ->
    if @_isNewEditor()
      return unless @newEditorView
      resetEditorState @newEditorView, getEpiditorContent content
    else
      @gdtEditor?.resetContent content

  focus: ->
    if @_isNewEditor()
      @newEditorView?.focus()
    else
      @gdtEditor?.focus()

  editorRef: (el) ->
    # when withApplyCancelButtons prop is true, EditorWIthApply is rendered which is a wrapper
    # around Editor, that is why need to get el.gdtEditor prop. Otherwise not wrapped Editor is
    # rendered, so it is safe to reference `el`
    @gdtEditor = if @props.withApplyCancelButtons then el?.gdtEditor else el

  _getInsertToggle: ->
    label: 'insert'
    onToggle: =>
      @gdtEditor.keepEditorActive()
      @setState showInsertModal: true

  _getCustomControls: ->
    referencesToggle = @getReferenceToggleSpec() unless @props.noReferencesInsert
    insertToggle = @_getInsertToggle() unless @props.noInsertOption
    _.compact [insertToggle, referencesToggle]

  _getCustomEntityRenderers: ->
    'GDT_TABLE': (Editor) =>
      component: InsertedGdtTable
      editable: false
      props:
        forceTableExpand: @props.forceTableExpand
        renderMode: @props.renderMode
        focusEditor: Editor.focus
        updateData: @updateEntityData
        isEditing: Editor.state.isEditing

  updateEntityData: (entityKey, newData, silent = false) ->
    editorUtils.updatedEntityData entityKey, newData
    if silent
      @saveContent()
    else
      mediator.dialogs.success 'Updated successfully'
      @gdtEditor.focus()

  closeInsertModal: ->
    @setState showInsertModal: false
    @gdtEditor.focus()

  onInsertModalSubmit: (insertData) ->
    { contentType, content } = insertData
    @closeInsertModal()

    if contentType is  'GDT_TABLE'
      gdtTableBlockSpec = type: 'GDT_TABLE', mutability: 'IMMUTABLE', data: content
      @gdtEditor.insertCustomBlock gdtTableBlockSpec
      content?.type is 'quality_indicators' and  @insertJustificationParagraph()
    else
      @gdtEditor.insertContent insertData

  insertJustificationParagraph: ->
    justificationData =
      contentType: 'HTML'
      content: "<br/><b>#{@i18n 'quality_indicators:table.justification'}:</b><br/>"
    _.defer =>
      @gdtEditor.insertContent justificationData

  onCancel: ->
    @gdtEditor.resetContent @props.content

  onApply: ->
    @saveContent()

  onBlur: (e) ->
    return if @props.noAutoSave
    # when onBlur is triggered by one of buttons from inserted table
    # then do not save content because it is being saved by updateEntityData method
    @saveContent() unless e.relatedTarget?.classList.contains 'inserted-table_button'

  saveContent: (handler = @props.onSaveContent) ->
    if @_isNewEditor()
      @_saveNewEditorContent @newEditorView, handler
    else
      @_saveOldEditorContent()

  _saveOldEditorContent: ->
    content = @gdtEditor.getEditorContent()
    options = isConsensus: @props.isConsensus
    @props.onSaveContent? { cellId: @props.cellId, content, options }

  saveAttachment: (file) ->
    attachmentName = "#{@props.cellId}/#{file.name.replace(/\s/g, '_')}"
    @props.onSaveAttachment? { attachmentName, file }
    attachmentName

  componentDidUpdate: (prevProps) ->
    return unless hasContentChanged prevProps.content, @props.content
    if @_isNewEditor()
      if @state.newEditorError
        @setState newEditorError: null
        return
      return unless @newEditorView
      try
        resetEditorState @newEditorView, getEpiditorContent @props.content
      catch error
        @newEditorView = null
        @setState newEditorError: error
    else
      @gdtEditor?.resetContent @props.content

  renderOldEditor: ->
    EditorComponent = if @props.withApplyCancelButtons then GdtEditorWithApply else GdtEditor

    <div className={@props.className || ""}>
      <EditorComponent
        attachments={@props.attachments}
        customControls={@_getCustomControls()}
        customEntityRenderers={@_getCustomEntityRenderers()}
        customDecorators={@getReferenceCitationDecorator()}
        customHandlers={handlePastedText: @handleReferencePaste}
        editorContent={@props.content}
        onChange={@props.onChange}
        onCancel={@onCancel}
        onApply={@onApply}
        onFocus={@props.onFocus}
        onBlur={@onBlur}
        placeholder={@props.placeholder}
        readOnly={not @props.editable}
        ref={@editorRef}
        stickControlsTo={@props.stickControlsTo}
        saveAttachment={@saveAttachment}
        showReferenceAttachments={@props.renderMode isnt 'printout'}
      />
      {if @state.showInsertModal
        <InsertModal
          additionalOptions={@props.additionalOptions}
          onClose={@closeInsertModal}
          onInsert={@onInsertModalSubmit}
        />
      }
      {if @state.showReferencesInsert
        <ReferencesInsertModal
          onInsert={@onInsertReferences}
          onClose={@toggleReferencesInsert}
        />
      }
    </div>

  handleNewEditorCancel: (view) -> =>
    resetEditorState view, getEpiditorContent @props.content
    @setState isNewEditorEditing: false

  handleNewEditorSave: (view) -> =>
    @_saveNewEditorContent view, @props.onSaveContent

  handleNewEditorBlur: (view, evt) ->
    return if @props.noAutoSave
    handler = @props.onBlur ? @props.onSaveContent
    if evt.relatedTarget is null
      @_saveNewEditorContent view, handler

  _saveNewEditorContent: (view = @newEditorView, handler = @props.onSaveContent) ->
    return unless view
    content = Immutable.fromJS serializeEditorStateWithNewEditor view.state
    options = isConsensus: @props.isConsensus
    resetSelection view
    @setState isNewEditorEditing: false
    handler? { cellId: @props.cellId, content, options }

  handleNewEditorChange: (state) ->
    @props.onChange? Immutable.fromJS serializeEditorStateWithNewEditor state

  handleNewEditorStartEdit: ->
    return if @props.renderMode is 'printout' or not @props.editable or @state.isNewEditorEditing
    @setState isNewEditorEditing: true
    @props.onFocus?()

  handleNewEditorReadonlyAttrsUpdate: (view) ->
    return if @state.isNewEditorEditing
    @_saveNewEditorContent view

  getNewEditorExtensions: ->
    applyCancelControlsExt = createControlExtension 'applyCancelControlsExt', ({ view }) =>
      <div className="apply-cancel-editor-controls">
        <button className="cancel-btn" onClick={@handleNewEditorCancel(view)}>
          {@i18n '/actions.cancel'}
        </button>
        <button className="apply-btn" onClick={@handleNewEditorSave(view)}>
          {@i18n '/actions.save'}
        </button>
      </div>
    disabledInsertFeatures = _.compact [
      'references' if @props.noReferencesInsert
    ]
    enabledInsertFeatures = _.compact [
      'gdtTables' unless @props.noInsertOption
    ]
    insertExt = insertExtension @props.renderMode is 'printout',
      disabledFeatures: disabledInsertFeatures
      enabledFeatures: enabledInsertFeatures
      gdtTableOptions:
        additionalOptions: @props.additionalOptions
        forceTableExpand: @props.forceTableExpand
        onReadonlyAttrsUpdate: @handleNewEditorReadonlyAttrsUpdate
      questionType: @props.questionType
    _.compact [
      applyCancelControlsExt if @props.withApplyCancelButtons
      insertExt
    ]

  newEditorContainerRef: (el) ->
    @newEditorContainer = el

  newEditorLoaded: (view) ->
    @newEditorView = view
    @setState newEditorError: null if @state.newEditorError

  renderNewEditor: ->
    editMode = if @props.renderMode is 'printout' or not @props.editable or not @state.isNewEditorEditing
      'readonly'
    else
      'edit'

    <EtdEditorErrorBoundary cellId={@props.cellId} content={@props.content} error={@state.newEditorError}>
      <EtdEpiditorContent
        cellId={@props.cellId}
        content={@props.content}
        containerRef={@newEditorContainerRef}
        extensions={@getNewEditorExtensions()}
        mode={editMode}
        minimal={@props.minimal}
        onBlur={@handleNewEditorBlur}
        onClick={@handleNewEditorStartEdit}
        onLoad={@newEditorLoaded}
        parentOverflowContainer={@newEditorContainer}
      />
    </EtdEditorErrorBoundary>

  render: ->
    if @_isNewEditor()
      @renderNewEditor()
    else
      @renderOldEditor()


EtdEpiditorContent = (props) ->
  <div className="etd-epiditor" ref={props.containerRef}>
    <EpiditorWithContext
      cellId={props.cellId}
      extensions={props.extensions}
      initialState={getEpiditorContent props.content}
      mode={props.mode}
      minimal={props.minimal}
      onBlur={props.onBlur}
      onClick={props.onClick}
      onLoad={props.onLoad}
      parentOverflowContainer={props.parentOverflowContainer}
    />
  </div>

EpiditorWithContext = (props) ->
  context = useEditorReady()

  useEffect ->
    context.registerEditor(props.cellId)
    undefined
  , []

  onLoad = useCallback (view) ->
    context.markReady props.cellId, view
    props.onLoad?(view)
  , [props.cellId, props.onLoad]

  <EpiditorComponent {..._.omit(props, 'onLoad')} onLoad={onLoad}/>

module.exports = EtdEditor
